/* eslint-disable no-unused-labels */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */

import { Client } from "@microsoft/microsoft-graph-client";
import { Ifeatures, IListField, IMailData, userSKU } from "./interfaces";

export const saveInList = async (
  mails: IMailData[],
  client: Client,
  listId: string,
  siteId: string,
  mailLink: string,
  // siteUrl: string,
  cfl: boolean,
  eFields: IListField[]
): Promise<string> => {
  console.log(mails, client);

  const _fields = [
    { name: "MailSubject", text: {} },
    { name: "MailFrom", text: {} },
    { name: "MailTo", text: {} },
    { name: "MailBody", text: { allowMultipleLines: true, textType: "richText" } },
    { name: "MailLink", text: { allowMultipleLines: true, textType: "richText" } },
  ];

  mails.forEach(async (mail: IMailData) => {
    if (cfl) {
      for (const field of _fields) {
        await client
          .api(`https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${listId}/columns`)
          .headers({ "Content-Type": "application/json" })
          .post(field)
          .then((response) => {
            console.log(response);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } //end of if

    console.log("mail--", mail);

    let temp = { fields: {} };

    if (cfl) {
      // @ts-ignore
      temp.fields.MailSubject = mail.originalSubject;
      //@ts-ignore
      temp.fields.MailFrom = mail.sender;
      //@ts-ignore
      temp.fields.MailTo = mail.receiver;
      // @ts-ignore
      temp.fields.MailBody = mail.body;
      // @ts-ignore
      temp.fields.MailLink = `<a href='${mailLink}' target='_blank'>Mail Link</a>`;
    }

    const o = JSON.parse(
      sessionStorage.getItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems")
    );

    if (o !== null) {
      o.forEach((x, _i) => {
        console.log(_i);
        const fieldType = eFields.find((o) => o.StaticName === x.key).TypeAsString;
        if (fieldType === "Lookup") {
          temp.fields[`${x.key}LookupId`] = x.value;
        } else if (typeof x.value === "boolean") {
          temp.fields[x.key] = x.value;
        } else {
          temp.fields[x.key] = x.value;
        }
      });
    }
    console.log(temp);
    await client
      .api(`https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${listId}/items`)
      .headers({ "Content-Type": "application/json" })
      .post(temp)
      .then(async (response) => {
        console.log(response);
        return "Mail copied successfully";
      })
      .catch((error) => {
        console.log("error", error);
        return "The mail cannot be copied";
      });
  });
  return "Mail copied successfully";
};

export const CheckPlan = async (client: Client, emailAddress: string): Promise<userSKU> => {
  try {
    const response = await client
      .api(`https://graph.microsoft.com/v1.0/users/${emailAddress}/licenseDetails`)
      .headers({ "Content-Type": "application/json" })
      .get();
    // response.value.map((item) => {
    console.log("response", response);
    const f: Ifeatures = {
      hasOneDrive: true,
      hasTeams: true,
      hasSP: true,
      hasMailHistory: true,
      hasPreview: true,
      hasSharebleLinks: true,
      boolean: true,
      hasNavigateSP: true,
      hasNavigateOneDrive: true,
      hasNavigateTeams: true,
      hasRenameMais: true,
      hasSaveMultipleMails: true,
      hasSendToTeamsMembers: true,
      hasSendToTeamsTags: true,
      hasSaveToDocsOneDrive: true,
      hasSaveToDocsSP: true,
      hasSaveToDocsTeams: true,
      hasSaveToLists: true,
      hasSaveAsEml: true,
      hasSaveAsPdf: true,
      hasSaveEmailAttachments: true,
      hasPinLocations: true,
      hasUpdateMetadata: true,
      hasOpenLocationsonBrowser: true,
      hasUsEntities: true,
    };

    const c: userSKU = {
      accountName: "psarakisantonis@e-study.gr",
      accountId: "",
      servicePlanId: "",
      servicePlanName: "",
      appliesTo: "",
      features: f,
    };

    return c;
  } catch (err) {
    console.log(err);
    throw err; // Re-throw the error after logging it
  }
};
